import React, { useImperativeHandle, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { FormInstance, Modal, Spin } from 'antd';
import { ModalProps } from 'antd/lib/modal';
import { filterFormParams } from '@/utils';
import CustomForm, { IFieldItem, IFormProps, IMyFormRef } from '../CustomForm';

interface ModalFormProp extends ModalProps {
  title?: string;
  myRef?: any;
  formAttr?: Array<IFieldItem>;
  value?: any;
  formProps?: IFormProps;
  confirmLoading?: boolean;
  detailLoading?: boolean;
  children?: React.ReactNode;
  onOk?: (value?: any) => void;
  onCancel?: (value?: any) => void;
  onValuesChange?: (changedValues?: any, value?: any) => void;
}
export interface ImodalFormRef extends FormInstance {
  closeModal?: () => void;
  openModal?: () => void;
}

const ModalForm: React.FC<ModalFormProp> = ({
  title = '',
  myRef,
  formAttr,
  value,
  formProps = {
    labelCol: { span: 5, offset: 1 },
    wrapperCol: { span: 14 },
    submitType: 'submit',
  },
  confirmLoading,
  detailLoading = false,
  children,
  onOk,
  onCancel,
  onValuesChange,
  ...rest
}) => {
  const [visible, setVisible] = useState<boolean>();
  const formRef = useRef<IMyFormRef>(null);
  const closeModal = () => {
    setVisible(false);
  };
  const openModal = () => {
    formRef.current?.resetFields();
    setVisible(true);
  };
  const handleOk = () => {
    if (formRef.current) {
      formRef.current.validateFields().then((values) => {
        if (onOk) {
          const { submitType } = formProps;
          onOk(submitType !== 'filter' ? values : filterFormParams(values));
        }
      });
    }
  };
  const handleCancel = () => {
    closeModal();
    if (onCancel) {
      onCancel();
    }
  };
  const handleValuesChange = async (changedValues, allValues) => {
    try {
      await formRef.current.validateFields(Object.keys(changedValues));
    } catch (error) {
      //
    } finally {
      onValuesChange?.(changedValues, allValues);
    }
  };
  useImperativeHandle(
    myRef,
    () => ({
      closeModal,
      openModal,
      ...formRef.current,
    }),
    [],
  );
  return (
    <>
      <Modal
        title={title}
        destroyOnClose
        forceRender
        maskClosable={false}
        open={visible}
        confirmLoading={confirmLoading}
        onOk={handleOk}
        onCancel={handleCancel}
        width={900}
        {...rest}
      >
        {children}
        <Spin spinning={detailLoading}>
          <CustomForm
            ref={formRef}
            formAttr={formAttr}
            value={value}
            onValuesChange={handleValuesChange}
            {...formProps}
          />
        </Spin>
      </Modal>
    </>
  );
};

const mapStateToProps = () => {
  return {};
};
const ConnectComponent: React.FC<ModalFormProp> = connect(
  mapStateToProps,
  {},
)(React.memo(ModalForm));

export default React.forwardRef<ImodalFormRef, ModalFormProp>((props, ref) => (
  <ConnectComponent {...props} myRef={ref} />
));
